import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { getSelectedSectionFromParams } from "../../../../../model";
import { DocstoreUploadForm } from "../model/types";

export function useDocstoreSectionModal() {
  const [searchParams] = useSearchParams();
  const selectedSection = getSelectedSectionFromParams(searchParams);

  const { control, handleSubmit, reset } = useForm<DocstoreUploadForm>({
    defaultValues: {
      document: null,
      fileType: "",
      qualityConfirmationType: "",
      documentName: "",
      description: "",
      documentNumber: "",
      issueDate: null,
      endDate: null,
      issuingOrganization: "",
      documentCode: "",
      pages: "",
      producer: "",
    },
  });

  return {
    selectedSection,
    control,
    handleSubmit,
    reset,
  };
}
